import { Component, OnInit, TemplateRef } from '@angular/core';
import { PeticionesHttpBackEndService } from '../../@core/mock/peticiones-http-backend.service'
import { Router, ActivatedRoute } from '@angular/router';
import { DomSanitizer, SafeHtml, SafeStyle, SafeScript, SafeUrl, SafeResourceUrl } from '@angular/platform-browser';
import { UtilidadesService } from '../../@core/utils/utilidades.service';
import { NbDialogService } from '@nebular/theme';
import { MatDialog } from '@angular/material';
import { ModalQuieroSerSocioComponent } from '../../custom_components/modal-quiero-ser-socio/modal-quiero-ser-socio.component';
import { DatePipe } from '@angular/common';

@Component({
  selector: 'ngx-actividad-detalle',
  templateUrl: './actividad-detalle.component.html',
  styleUrls: ['./actividad-detalle.component.scss']
})
export class ActividadDetalleComponent implements OnInit {

  Actividad: any;
  contenidoVisible: Boolean = false;
  parametrosUrl: any;
  parallax: any;
  ComprobarPago:any;
  confirmacionTransferencia:boolean = true;
  pagado:boolean = true;
  enEspera:boolean = false;
  asistir:boolean = true;
  noPagado:boolean = true;
  EsEmpresa:boolean = false;
  avisoEsEmpresa:boolean = false;
  esSocio:any;
  EntidadId:any;
  datepipe:any;

  constructor(public dialog: MatDialog,private router: Router, private sanitizer: DomSanitizer, private _route: ActivatedRoute,datepipe: DatePipe, private _http: PeticionesHttpBackEndService,private utilidades: UtilidadesService,private dialogService: NbDialogService) { 
    this.Actividad = {Actividad:[]};
    this.datepipe = datepipe;
    this._route.queryParams.subscribe(params => {
      this.parametrosUrl = params || null;
      this.esSocio = this.parametrosUrl.esSocio;
      this.asistir = this.esSocio;
    });
  }
 
  ngOnInit() {
    this._http.getOnePublic("actividad",this.parametrosUrl["id"]).subscribe(
      result => {
        this.Actividad = result;
        this.contenidoVisible = true;
        this.parallax = this.sanitizer.bypassSecurityTrustStyle(`background-image: url(${this.Actividad.ImgB64})`);
      }
    );
      if(this._http.comprobarLogin()){
    this._http.getOneReg("v1/comprobarPago",this.parametrosUrl["id"]).subscribe(
      result => {
        this.ComprobarPago = result;
        this.EntidadId=this.ComprobarPago.Entidad;
        this.EsEmpresa = this.ComprobarPago.EsEmpresa;
        
        this.ComprobarPago.ComprobarPago;
        if(this.ComprobarPago.EsListaEspera){
            this.enEspera = true;
        }else{
          this.enEspera = false;
            if(this.ComprobarPago.ComprobarPago != undefined && this.ComprobarPago.ComprobarPago.length > 0){
              if(this.ComprobarPago.ComprobarPago[0]._confirmacion_pago != undefined && this.ComprobarPago.ComprobarPago[0]._tipo_pago_id != undefined 
                && this.ComprobarPago.ComprobarPago[0]._tipo_pago_id._descripcion != undefined 
                && !this.ComprobarPago.ComprobarPago[0]._confirmacion_pago && this.ComprobarPago.ComprobarPago[0]._tipo_pago_id._descripcion == "Transferencia"){
                    this.confirmacionTransferencia = false;

              }else if(this.ComprobarPago.ComprobarPago[0]._confirmacion_pago != undefined && this.ComprobarPago.ComprobarPago[0]._confirmacion_pago){
                this.pagado = false;
                this.noPagado = false;
              }else if(this.ComprobarPago.ComprobarPago[0]._confirmacion_pago != undefined && !this.ComprobarPago.ComprobarPago[0]._confirmacion_pago){
                this.pagado = true;
              }
          }
          else{
            this.asistir = false;
          }
        }
        
      }
    );
      }
  }
  activeModal: any;
  abrirModal(dialog: TemplateRef<any>) {
    this.activeModal = this.dialogService.open(dialog, {});
  }
  AsistirActividad(dialog: TemplateRef<any>,dialogListaEspera: TemplateRef<any>){
    this._http.getOnePublic("actividad",this.parametrosUrl["id"]).subscribe(
      result => {
        this.Actividad = {Actividad:[]};
        this.Actividad = result;
        this.contenidoVisible = true;
        this.parallax = this.sanitizer.bypassSecurityTrustStyle(`background-image: url(${this.Actividad.ImgB64})`);
        if(dialog != null && this.Actividad.Actividad._desactivar){
          this.utilidades.notificationWarning("Aviso","La actividad esta deshabilitada, si necesita mas información consulte con sedic@sedic.es","top-left");
        }else if(this.Actividad.Actividad._fecha_inicio_inscripcion != null && this.datepipe.transform(this.Actividad.Actividad._fecha_inicio_inscripcion, "yyyy-MM-dd") < this.datepipe.transform(new Date(), "yyyy-MM-dd")){
          this.utilidades.notificationWarning("Aviso","No puede inscribirse en la actividad, se ha superado el limite de fecha de inscripción, si necesita mas información consulte con sedic@sedic.es","top-left");
        }else if(this.Actividad.Actividad._solo_socios && this.esSocio=="false"){
          this.abrirModal(dialog);
        //this.utilidades.notificationWarning("Aviso","Solo los socios pueden inscribirse a esta actividad","top-left");
        }else if(!this.Actividad.PlazasLibres){
          if(!this.EsEmpresa){
            this.abrirModal(dialogListaEspera);
          }else{
            this.avisoEsEmpresa = true;
            this.utilidades.notificationWarning("Aviso","No puede inscribise como una empresa, si quiere inscribir a sus trabajadores siga las instrucciones","top-left");
          }
        }else{
          if(!this.EsEmpresa){
            this.avisoEsEmpresa = false;
            let objeto: any;
            let resultadoCheckToken: any;
            objeto = '{"ActividadId":'+this.parametrosUrl["id"]+'}';
            localStorage.setItem("C_BUY", objeto);
    
            if (localStorage.getItem('auth_app_token')){
              this._http.checkToken().subscribe(
                result => {
                  resultadoCheckToken = result;
                  if (resultadoCheckToken.Code == 200){
                    this.router.navigate(['private/proceso-compra']);
                  }else{
                    this.router.navigate(['public/compra-actividad-aviso']);
                  }          
                },
                error => {
                  this.router.navigate(['public/compra-actividad-aviso']);
                }
              );
            }else{
              this.router.navigate(['public/compra-actividad-aviso']);
            }
          }else{
            this.avisoEsEmpresa = true;
            this.utilidades.notificationWarning("Aviso","No puede inscribise como una empresa, si quiere inscribir a sus trabajadores siga las instrucciones","top-left");
          }
      }
      }
    );
   
  }
  close() {
    this.activeModal.close();
  }
  resultConsultaSocio:any;
  quieroSerSocio(){
    this._http.getAllReg("v1/conPeticionSocio/"+this.EntidadId).subscribe(
      result => {
        this.resultConsultaSocio = result;
        if(this.resultConsultaSocio.SolicitudesSocios > 0){
          this.utilidades.notificationWarning("Aviso","Esta pendiente de validacion","top-left");
        }else{
          let dialogRef = this.dialog.open(ModalQuieroSerSocioComponent, {
            panelClass: 'custom-dialog',
            data: {
              titulo: "User",
              entidadId: this.EntidadId
            }
          });
                
          dialogRef.afterClosed().subscribe(result => {
            this.close();
          });
        }
      },
      error => {

      }
    );
  }
  resultadoListaEspera:any;
  inserListaEspera(){
    this._http.postRequest("v1/insertListaEspera",{
      Actividad:this.parametrosUrl["id"]
    }).subscribe(
      result => {
        this.resultadoListaEspera = result;
        this.utilidades.notificationSuccess("Succes",this.resultadoListaEspera.Mensaje,"top-left");
        this.activeModal.close();
        this.router.navigate(['public/inicio']);
      }
    )
  }
}
